import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
import userService from "../services/userService";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // Cadastro de material
    material_checked: false,
    register_material: "",
    description_material: "",
    material_photo: "",
    bag_photo: "",
    // Materiais e info do usuário
    document: sessionStorage.getItem("document"),
    region: sessionStorage.getItem("region"),
    uid: sessionStorage.getItem("uid"),
    bag_number: "",
    bag_description: "",
    bag_type: "",
    register_date: "",
    type_bo: "",
    img_bo: "",
    materials: [],
    search: "",
    transfered_materials: "",
    token_login: sessionStorage.getItem("tokenLogin"),
    refreshToken: sessionStorage.getItem("token"),
    user: {},
    // Para transferência de material
    receiver_id: "",
    receiver_id_type: "",
    is_checked: false,
    receiver_name: "",
    // Renderização de passo a passo
    step_number: 1,
    step_stole: 1,
    step_register: 1,
    // Mensagem de erro exibida pelo ErrorModal (vazia = modal fechado)
    error_message: "",
    // Rota para onde o botão Voltar do ErrorModal leva (vazia = apenas fecha)
    error_redirect: "",
    // Se possui ou não material e renderizar de acordo
    hasMaterials: "waiting",
    // Filtro de status da lista (active | transferring | inactive)
    materialStatusFilter: "active",
    // Token de autenticação para upload aws
    token: "",
  },
  mutations: {
    setMaterialChecked(state, payload) {
      state.material_checked = payload;
    },
    setRegisterMaterial(state, payload) {
      state.register_material = payload;
    },
    setDescriptionMaterial(state, payload) {
      state.description_material = payload;
    },
    setMaterialPhoto(state, payload) {
      state.material_photo = payload;
    },
    setBagPhoto(state, payload) {
      state.bag_photo = payload;
    },
    setIsChecked(state, payload) {
      state.is_checked = payload;
    },
    setBagDescription(state, payload) {
      state.bag_description = payload;
    },
    setBagNumber(state, payload) {
      state.bag_number = payload;
    },
    setRegisterDate(state, payload) {
      state.register_date = payload;
    },
    setBagType(state, payload) {
      state.bag_type = payload;
    },
    setImgBO(state, payload) {
      state.img_bo = payload;
    },
    setTypeBO(state, payload) {
      state.type_bo = payload;
    },
    setStepNumber(state, payload) {
      state.step_number = payload;
    },
    setStepRegister(state, payload) {
      state.step_register = payload;
    },
    setStepStole(state, payload) {
      state.step_stole = payload;
    },
    setReceiverId(state, payload) {
      state.receiver_id = payload.value;
      state.receiver_id_type = payload.type;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setErrorMessage(state, payload) {
      state.error_message = payload;
    },
    setErrorRedirect(state, payload) {
      state.error_redirect = payload;
    },
    setHasMaterials(state, payload) {
      state.hasMaterials = payload;
    },
    setMaterialStatusFilter(state, payload) {
      state.materialStatusFilter = payload;
    },
    setMaterials(state, payload) {
      state.materials = payload;
    },
    setSearch(state, payload) {
      state.search = payload;
    },
    setTransferedMaterials(state, payload) {
      state.transfered_materials = payload;
    },
    setReceiverName(state, payload) {
      state.receiver_name = payload;
    },
    setDocument(state, payload) {
      state.document = payload;
    },
    SET_REFRESH_TOKEN(state, payload) {
      state.refreshToken = payload;
    },
    SET_TOKEN(state, payload) {
      state.token_login = payload;
    },
    SET_AUTH_USER(state, payload) {
      state.user = payload;
    },
  },
  actions: {
    async driver({ commit }, payload) {
      try {
        const isInvalid =
          !payload ||
          typeof payload !== "object" ||
          !payload.tk ||
          payload.tk === "undefined";
        if (isInvalid) {
          console.error("driver: payload inválido (objeto com tk, doc, nam, region, uid esperado)");
          return Promise.reject(new Error("Dados de login incompletos. Use o link completo."));
        }
        const doc = payload.doc ?? payload.uid ?? "";
        const nam = payload.nam ?? "";
        const region = payload.region ?? "";
        const uid = payload.uid ?? doc;
        const tk = payload.tk;
        if (!tk || tk === "undefined") {
          return Promise.reject(new Error("Token de login inválido."));
        }
        commit("SET_TOKEN", tk);
        commit("setDocument", doc);
        sessionStorage.setItem("user", nam);
        sessionStorage.setItem("mobile", 1);
        sessionStorage.setItem("document", doc);
        sessionStorage.setItem("tokenLogin", tk);
        sessionStorage.setItem("region", region);
        sessionStorage.setItem("uid", uid);
        window.location.href = "/meus-materiais";
      } catch (error) {
        console.error(error);
        return error;
      }
    },
    async login({ commit }, payload) {
      try {
        const { data } = await userService.loginUser(payload);
        const user = data.item.user;
        const auth = data.item.auth;
        commit("SET_AUTH_USER", user);
        commit("SET_TOKEN", auth.token);
        commit("SET_REFRESH_TOKEN", auth.refresh_token);
        commit("setDocument", user.email);
        sessionStorage.setItem("user", user.name);
        sessionStorage.setItem("token", auth.refresh_token);
        sessionStorage.setItem("document", user.email);
        sessionStorage.setItem("tokenLogin", auth.token);
        sessionStorage.setItem("region", user.profile);
        sessionStorage.setItem("uid", user.id);
      } catch (error) {
        console.error(error);
        return error;
      }
    },
    async signIn({ commit }, payload) {
      try {
        const { data } = await userService.signInUser(payload);
        commit("SET_AUTH_USER", {});
        return data.message;
      } catch (error) {
        console.error(error);
        return error;
      }
    },
    async register({ commit }, payload) {
      try {
        const { data } = await userService.registerUser(payload);
        commit("SET_AUTH_USER", {});
        return data;
      } catch (error) {
        console.error(error);
        return error;
      }
    },
    async searchZip({ commit }, payload) {
      try {
        const { data } = await userService.zip(payload);
        commit("SET_AUTH_USER", {});
        return data;
      } catch (error) {
        console.error(error);
        return error;
      }
    },
    logout() {
      const eventosReturnUrl = sessionStorage.getItem("eventos_return_url");
      sessionStorage.clear();
      if (eventosReturnUrl) {
        window.location.href = eventosReturnUrl;
        return;
      }
      router.push("/");
      window.location.reload();
    },
  },
  getters: {
    isAuthenticated: (state) => {
      const token = state.token_login;
      const refresh = state.refreshToken;
      const validToken = token != null && token !== "undefined" && token !== "";
      const validRefresh = refresh != null && refresh !== "undefined" && refresh !== "";
      return validToken || validRefresh;
    },
  },
});
